module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./PictureListView.js"));
	}, "PictureListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PictureListView!./src/pages/Promote/OfflineActivity/ActivityPicture/PictureList/PictureListView.js
// module id = 1689
// module chunks = 418